import React, { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { Gift, X, Loader2 } from "lucide-react";
import { API, auth, TOK } from "./shared";

const SERIF = '"Cormorant Garamond", Georgia, serif';
const SANS = '"Manrope", sans-serif';
const field = "w-full rounded-2xl px-4 py-3 bg-transparent outline-none text-base";

// Premium: who the installation is for and a note from the giver, before the normal Create flow.
export const GiftIntro = ({ onStart, onClose }) => {
  const [me, setMe] = useState(null);
  const [name, setName] = useState("");
  const [note, setNote] = useState("");
  useEffect(() => { axios.get(`${API}/api/voice-clone/me`, auth()).then((r) => setMe(r.data)).catch(() => setMe({})); }, []);
  const left = me?.premium ? Math.max(0, 2 - (me.gifts_used || 0)) : 0;
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} data-testid="gift-intro"
      className="fixed inset-0 z-[120] flex items-end sm:items-center justify-center px-4 py-6" style={{ background: "rgba(5,10,24,0.86)", backdropFilter: "blur(14px)" }}>
      <div className="relative w-full max-w-md rounded-3xl px-6 py-8" style={{ background: TOK.ink || "#0B1430", border: `1px solid ${TOK.goldMist}` }}>
        <button type="button" onClick={onClose} aria-label="Close" className="absolute top-4 right-4" style={{ color: TOK.creamMist }} data-testid="gift-intro-close"><X size={18} /></button>
        <Gift size={22} style={{ color: TOK.gold }} />
        <h2 className="mt-3 text-3xl font-light" style={{ fontFamily: SERIF, color: TOK.cream }}>Make an installation as a gift</h2>
        {!me ? <Loader2 className="mt-6 animate-spin" style={{ color: TOK.gold }} /> : !me.premium ? (
          <div className="mt-4 space-y-4" data-testid="gift-intro-premium-only">
            <p className="text-sm" style={{ color: TOK.creamDim, fontFamily: SANS }}>Gifts are part of My Voice Premium: 2 a month, made for someone you love.</p>
            <a href="/voice-clone" className="inline-flex rounded-full px-6 py-3 text-[0.68rem] uppercase tracking-[0.22em]" style={{ background: TOK.gold, color: TOK.ink, fontFamily: SANS }} data-testid="gift-intro-go-premium">See Premium</a>
          </div>
        ) : (
          <div className="mt-4 space-y-4">
            <p className="text-sm" style={{ color: TOK.creamDim, fontFamily: SANS }} data-testid="gift-intro-left">{left} of 2 gifts left this month. You'll choose the voice in a moment.</p>
            <input value={name} onChange={(e) => setName(e.target.value.slice(0, 60))} placeholder="Who is it for?" className={field} style={{ border: `1px solid ${TOK.goldMist}`, color: TOK.cream, fontFamily: SANS }} data-testid="gift-intro-name" />
            <textarea value={note} onChange={(e) => setNote(e.target.value.slice(0, 400))} rows={3} placeholder="A note from you (optional)" className={field} style={{ border: `1px solid ${TOK.goldMist}`, color: TOK.cream, fontFamily: SANS }} data-testid="gift-intro-note" />
            <button type="button" disabled={!name.trim() || !left} onClick={() => onStart({ for: name.trim(), note: note.trim() })} data-testid="gift-intro-start"
              className="w-full rounded-full py-3.5 text-[0.7rem] uppercase tracking-[0.24em] disabled:opacity-40" style={{ background: TOK.gold, color: TOK.ink, fontFamily: SANS }}>
              Create their installation
            </button>
          </div>
        )}
      </div>
    </motion.div>
  );
};
